import { css } from "@emotion/react";
import React from "react";

export const FormItemLayoutWrapper: React.FC<{ children: React.ReactNode; className?: string }> = ({
    children,
    className,
}) => {
    return (
        <div
            className={className ?? ""}
            css={css`
                .ant-form-item-row {
                    flex-direction: row !important;
                }
            `}
        >
            {children}
        </div>
    );
};
